import { NewPartner } from "src/entities/partners";
export function NewPartnerPage() {
  return <NewPartner />;
}
